// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"c49132de","502":"ff1d2de9","956":"7f2b848b"}[chunkId] + ".chunk.js";
};